import SidebarContents from '@activities/MainActivity/components/MainLayout/Sidebar/SidebarContents';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

import SidebarHeader from './SidebarHeader';

function Sidebar() {
    return (
        <Container>
            <SidebarHeader/>
            <SidebarContents/>
            <IndexText color={colors.red} fontWeight='medium' size='display'>
                2
            </IndexText>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    position: relative;
    pointer-events: none;
`;

const IndexText = styled(Text)`
    position: absolute;
    right:  90px;
    top: 140px;
`;

export default Sidebar;
